import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStudyById } from '../../utils/API_SERVICE_FOR_PATIENT_PAGE'
import { useStudyId } from '../../Hooks/useStudyId'
import { useSearchParams } from 'react-router-dom'

function StudyDetails() {
  const { t } = useTranslation('common');
  
  const [searchParams] = useSearchParams();
  const propStudyId = searchParams.get("StudyId");
  const studyId = useStudyId(propStudyId);
  const { data: studyData } = useStudyById(studyId);
  
  const [selectedSecValue, setSelectedSecValue] = useState("");
  const [selectedFisValue, setSelectedFisValue] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");

  // Update country when studyData loads
  useEffect(() => {
    if (studyData?.studyInProgress?.clinicCountry) {
      // Map country name to flag key
      const countryName = studyData.studyInProgress.clinicCountry.trim();
      if (countryName.includes("United States") || countryName.includes("USA")) {
        setSelectedCountry("USA");
      } else if (countryName.includes("Canada")) {
        setSelectedCountry("Canada");
      } else if (countryName.includes("Pakistan")) {
        setSelectedCountry("Pakistan");
      } else if (countryName.includes("Saudia") || countryName.includes("Saudi")) {
        setSelectedCountry("Saudia");
      } else if (countryName.includes("Oman")) {
        setSelectedCountry("Oman");
      }
    }
  }, [studyData]);

  const flags = {
    USA: "🇺🇸",
    Canada: "🇨🇦",
    Pakistan: "🇵🇰",
    Saudia: "🇸🇦",
    Oman: "🇴🇲",
  };


  return (
    <div className="dark:bg-gray-900">
      
      <div className='bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-3xl mt-10 p-2 shadow-sm dark:shadow-gray-900'>

        <div className='bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6'>
          <div>
            <h1 className="text-gray-900 dark:text-gray-100 font-semibold">{t('studyDetails')}</h1>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-7 gap-2 place-content-center'>

            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('studyType')}</label>
              <select
                id="study-type"
                className="w-full border border-gray-300 dark:border-gray-600 p-3 rounded-full mt-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600 cursor-pointer"
                value={studyData?.studyDescription || ""}
                disabled
              >
                <option value="">{studyData?.studyDescription || t('selectStudyType')}</option>
              </select>
            </div>
            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('modalityType')}</label>
              <select 
                id="modality-type"
                className="w-auto border border-gray-300 dark:border-gray-600 p-3 rounded-full mt-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600 cursor-pointer"
                value={studyData?.modalityName || ""}
                disabled
              >
                <option value="">{studyData?.modalityName || t('selectModalityType')}</option>
              </select>
            </div>
            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('anatomicRegions')}</label>
              <select
                id="anatomic-regions"
                className="w-auto border border-gray-300 dark:border-gray-600 p-3 rounded-full mt-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600 cursor-pointer"
                value={studyData?.studyDescription || ""}
                disabled
              >
                <option value="">{studyData?.studyDescription || t('selectAnatomicRegion')}</option>
              </select>
            </div>


          </div>
        </div>
        <div className='bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-2'>
          <div>
            <h1 className="text-gray-900 dark:text-gray-100 font-semibold">{t('clinicalHistory')}</h1>
          </div>
          <div className='bg-white dark:bg-gray-800 p-6 m-3 rounded-2xl text-[#5F6368] dark:text-gray-300 shadow-sm dark:shadow-gray-900'>
            {studyData?.clinicalHistory ? (
              <div dangerouslySetInnerHTML={{ __html: studyData.clinicalHistory }} />
            ) : (
              <h1>{t('noClinicalHistory')}</h1>
            )}
          </div>
          <div className='mt-2.5 mx-3 flex flex-col xl:flex-row gap-1'>
            <div className="flex flex-col md:flex-row gap-1 space-y-2.5 md:space-y-0">
              <div className="bg-white dark:bg-gray-800 h-12 w-auto sm:w-96 rounded-full p-2.5 text-[#5F6368] dark:text-gray-300 shadow-sm dark:shadow-gray-900">
                <h1>{t('hasBeenAdministered')}</h1>
              </div>
              <div className="flex gap-1">
                {/* Yes Radio Button */}
                <div
                  className={`gap-3 flex py-3 place-content-center h-12 w-24 rounded-full ${
                    selectedFisValue === "yes1" 
                      ? "bg-[#CBEA7B80] dark:bg-[#A4C63980]" 
                      : "bg-white dark:bg-gray-800"
                  } shadow-sm dark:shadow-gray-900 text-gray-900 dark:text-gray-100`}
                >
                  <div>
                    <input
                      type="radio"
                      name="contrast"
                      id="yes1"
                      value="yes1"
                      checked={selectedFisValue === "yes1"}
                      onChange={() => setSelectedFisValue("yes1")}
                      className="accent-[#CBEA7B] dark:accent-[#A4C639]"
                    />
                  </div>
                  <div>
                    <span>{t('yes')}</span>
                  </div>
                </div>
                {/* No Radio Button */}
                <div
                  className={`gap-3 flex py-3 place-content-center h-12 w-24 rounded-full ${
                    selectedFisValue === "no1" 
                      ? "bg-[#CBEA7B80] dark:bg-[#A4C63980]" 
                      : "bg-white dark:bg-gray-800"
                  } shadow-sm dark:shadow-gray-900 text-gray-900 dark:text-gray-100`}
                >
                  <div>
                    <input
                      type="radio"
                      name="contrast"
                      id="no1"
                      value="no1"
                      checked={selectedFisValue === "no1"}
                      onChange={() => setSelectedFisValue("no1")}
                      className="accent-[#CBEA7B] dark:accent-[#A4C639]"
                    />
                  </div>
                  <div>
                    <span>{t('no')}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-1 space-y-2.5 md:space-y-0 mt-2.5 xl:mt-0">
              <div className="bg-white dark:bg-gray-800 h-12 w-auto sm:w-96 rounded-full p-2.5 text-[#5F6368] dark:text-gray-300 shadow-sm dark:shadow-gray-900">
                <h1>{t('hasBeenAdministered')}</h1>
              </div>
              <div className="flex gap-1">
                {/* Yes Radio Button */}
                <div
                  className={`gap-3 flex py-3 place-content-center h-12 w-24 rounded-full ${
                    selectedSecValue === "yes2" 
                      ? "bg-[#CBEA7B80] dark:bg-[#A4C63980]" 
                      : "bg-white dark:bg-gray-800"
                  } shadow-sm dark:shadow-gray-900 text-gray-900 dark:text-gray-100`}
                >
                  <div>
                    <input
                      type="radio"
                      name="administered"
                      id="yes2"
                      value="yes2"
                      checked={selectedSecValue === "yes2"}
                      onChange={() => setSelectedSecValue("yes2")}
                      className="accent-[#CBEA7B] dark:accent-[#A4C639]"
                    />
                  </div>
                  <div>
                    <span>{t('yes')}</span>
                  </div>
                </div>
                {/* No Radio Button */}
                <div
                  className={`gap-3 flex py-3 place-content-center h-12 w-24 rounded-full ${
                    selectedSecValue === "no2" 
                      ? "bg-[#CBEA7B80] dark:bg-[#A4C63980]" 
                      : "bg-white dark:bg-gray-800"
                  } shadow-sm dark:shadow-gray-900 text-gray-900 dark:text-gray-100`}
                >
                  <div>
                    <input
                      type="radio"
                      name="administered"
                      id="no2"
                      value="no2"
                      checked={selectedSecValue === "no2"}
                      onChange={() => setSelectedSecValue("no2")}
                      className="accent-[#CBEA7B] dark:accent-[#A4C639]"
                    />
                  </div>
                  <div>
                    <span>{t('no')}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className='bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-3'>
          <div>
            <h1 className="text-gray-900 dark:text-gray-100 font-semibold">{t('clinicalInformation')}</h1>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-7 gap-2 place-content-center'>

            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('clinicName')}</label>
              <input 
                type="text" 
                required 
                className='h-12 w-full p-2 mt-2 rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600' 
                value={studyData?.clinicName || ""}
                readOnly
              />
            </div>
            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('physicianName')}</label>
              <input 
                type="text" 
                className='h-12 w-full p-2 mt-2 rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600' 
                value={studyData?.physicianName || ""}
                readOnly
              />
            </div>
            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('credentials')}</label>
              <input 
                type="text" 
                className='h-12 w-full p-2 mt-2 rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600' 
                value={studyData?.vetToolTip || ""}
                readOnly
              />
            </div>
            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('country')}</label>
              <div className="relative w-full">
                <span className="absolute left-2 top-1/2 place-content-center justify-items-center h-8 w-8 mt-1 transform -translate-y-1/2 bg-gray-200 dark:bg-gray-600 rounded-full px-1.5 flex items-center justify-center">
                  {flags[selectedCountry] || "🌐"}
                </span>
                <select
                  id="country"
                  className="w-full p-3 rounded-full mt-2 pl-16 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600 cursor-pointer"
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                  disabled
                >
                  <option value="">{studyData?.studyInProgress?.clinicCountry || t('selectCountry')}</option>
                  <option value="USA" className='cursor-pointer'>USA</option>
                  <option value="Canada" className='cursor-pointer'>Canada</option>
                  <option value="Pakistan" className='cursor-pointer'>Pakistan</option>
                  <option value="Saudia" className='cursor-pointer'>Saudia</option>
                  <option value="Oman" className='cursor-pointer'>Oman</option>
                </select>
              </div>
            </div>
            <div className='flex flex-col'>
              <label htmlFor="" className="text-gray-700 dark:text-gray-300 mb-1">{t('phoneNumber')}</label>
              <div className="relative w-full">
                <span className="absolute left-2 top-1/2 place-content-center justify-items-center h-8 w-8 mt-1 transform -translate-y-1/2 bg-gray-200 dark:bg-gray-600 rounded-full px-1.5 flex items-center justify-center">
                  {flags[selectedCountry] || "🌐"}
                </span>
                <input
                  type="text"
                  className="w-full p-3 rounded-full mt-2 pl-16 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600"
                  value={studyData?.wetreadYourlocation || ""}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudyDetails
